import React, { Fragment } from 'react';
import { useLocation } from 'react-router-dom';
import { DidYouMean, MAX_DID_YOU_MEAN_OPTIONS, DidYouMeanLinkStyled, } from '@yme/molecules/did-you-mean';
import { getDidYouMeanSearchParams } from '@yme/pages/components/ProductsGrid/components/AccessoriesFilterBloomreach/helpers';
import { useTranslation } from '@yme/services/i18n';
export function DidYouMeanForGrid({ query, searchResultsPageUrl, autoCorrectQueryResult, didYouMeanOptions, }) {
    const { t } = useTranslation();
    const { search } = useLocation();
    const didYouMeanElements = (React.createElement(React.Fragment, null, didYouMeanOptions.slice(0, MAX_DID_YOU_MEAN_OPTIONS).map((option, index, array) => (React.createElement(Fragment, { key: option },
        "\"",
        React.createElement(DidYouMeanLinkStyled, { to: {
                pathname: searchResultsPageUrl,
                search: getDidYouMeanSearchParams(option, search),
            } }, option),
        "\"",
        array.length > 0 && index + 1 !== array.length && React.createElement(React.Fragment, null,
            " ",
            t('common_or_label'),
            " "))))));
    return (React.createElement(DidYouMean, { query: query, autoCorrectQueryResult: autoCorrectQueryResult, didYouMeanOptions: didYouMeanOptions, didYouMeanElements: didYouMeanElements }));
}
